import type { LocationData } from 'owa-window-data';
import type { LocationBootstrapSettings } from 'owa-worker-types';

export class WorkerLocationData implements LocationData {
    _location: LocationBootstrapSettings;

    constructor(l: LocationBootstrapSettings) {
        this._location = l;
    }

    get search(): string {
        return this._location.search;
    }

    set search(_) {}

    get protocol(): string {
        return this._location.protocol;
    }

    get host(): string {
        return this._location.host;
    }

    get hostname(): string {
        return this._location.hostname;
    }

    get href(): string {
        return this._location.href;
    }

    get pathname(): string {
        return this._location.pathname;
    }

    get hash(): string {
        return this._location.hash;
    }

    get origin(): string {
        return this._location.origin;
    }

    get port(): string {
        return this._location.port;
    }
}
